import React from "react";
import styled, { css } from "styled-components";

export default function Button({
  padding = [20, 40],
  bg = "--light-blue",
  color = "--white",
  children,
  radius = 100,
  fontSize = 18,
  fontWeight = 500,
  fill = false,
  hover = '',
  ...props
}) {
  padding = padding.join("px ") + "px";

  return (
    <StyledButton
      $padding={padding}
      $bg={bg}
      $color={color}
      $radius={radius}
      $fontSize={fontSize}
      $fontWeight={fontWeight}
      $fill={fill}
      $hover={hover}
      {...props}
    >
      {children}
    </StyledButton>
  );
}

const StyledButton = styled.button`
  background-color: var(${(props) => props.$bg});
  padding: ${(props) => props.$padding};
  color: var(${(props) => props.$color});
  border-radius: ${(props) => props.$radius}px;
  border: 1.5px solid transparent;
  cursor: pointer;
  font-size: ${(props) => props.$fontSize}px;
  font-weight: ${(props) => props.$fontWeight};
  font-style: normal;
  line-height: ${(props) => Number(props.$fontSize) + 6}px;
  transition: 0.4s ease;
  width: ${({ $fill }) => ($fill ? "100%" : "auto")};

  &:hover {
    background-color: transparent;
    color: var(${(props) => props.$bg});
    border-color: var(${(props) => props.$bg});

    ${({$hover}) => $hover === 'white' && css`
      color: var(--white);
      border-color: var(--white);
    `}
  }
`;
